module.exports = __webpack_public_path__ + "img/my-location.4c0601c7.svg";